import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const ModalWindowAddNewUser = (props) => {
  return (
    <div>
      <Modal
        show={props.isShowWindow}
        onHide={props.onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered={true}
        backdrop={true}
      >
        <Modal.Body>
          <h4 className="mt-2 mb-4">Add new user</h4>
          {props.errorMsg && (
            <span className="badge text-bg-danger">{props.errorMsg}</span>
          )}
          <form>
            <div className="mb-3">
              <p>Username, minimum 3 characters</p>
              <input
                type="text"
                className="form-control"
                onChange={props.handleNewUserUsername}
              ></input>
            </div>
            {props.errUsernameMsg && (
              <span className="badge text-bg-danger">
                {props.errUsernameMsg}
              </span>
            )}
            <div className="mb-3">
              <p>Password, minimum 3 characters</p>
              <input
                type="password"
                className="form-control"
                onChange={props.handleNewUserPassword}
              ></input>
            </div>
            {props.errPassMsg && (
              <span className="badge text-bg-danger">{props.errPassMsg}</span>
            )}
            <div className="mb-3">
              <p>Role</p>
              <select
                className="form-select"
                value={props.newUserRole}
                onChange={props.handleNewUserRole}
              >
                <option value="CLIENT">CLIENT</option>
                <option value="ADMIN">ADMIN</option>
              </select>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="large-button grey" onClick={props.onHide}>
            CLOSE
          </button>
          {props.isShowAddNewUserButton && (
            <button
              type="button"
              onClick={props.handleAddNewUserSubmit}
              className="large-button green"
            >
              ADD NEW USER
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default ModalWindowAddNewUser;
